import axios from "axios";
import { PageType } from "types/PageI";
import { ResponseError } from "types/responses/ResponseError";

const API_URL = process.env.REACT_APP_API_URL;

export async function CreateAccountService(new_user, language: any) {
    try {

        const response = await axios.post(
            API_URL + '/create_account', 
            {
                user: new_user,
                language: language,
                return_url: window.location.href    
            })
        
        if ('error' in response.data) {    
            return response.data.error
        } 

        if ("user" in response.data) {
            // return response.data.user       
            return PageType.verify_email     
        }

        return "no_user_error"


    } catch (error) {
        return "create_account_error"
    }
}